/* eslint-disable @typescript-eslint/quotes */
/* eslint-disable max-len */
export const foodlist = [
  {
    name: 'Oranges',
    canDogsEat: 'Moderate',
    dogNotes:
      'Dogs can eat oranges. But only give them a little bit of orange flesh. Avoid feeding them pith, seeds, or peel.',
    canCatsEat: 'No',
    catNotes: 'Oranges contain psoralens and essential oils that irritate cats’ stomach and nervous system; even the peel or seeds are harmful. Flesh rarely eaten by cats tends to cause vomiting or diarrhea.',
  },
  {
    name: 'Lemons',
    canDogsEat: 'No',
    dogNotes:
      'The psoralen compounds and aromatic oils in lemons are toxic to dogs and can cause an upset stomach.',
    canCatsEat: 'No',
    catNotes: 'Lemons are highly acidic and contains psoralen compounds and oils that are toxic to cats; can cause GI upset, drooling, tremors, lethargy.',
  },
  {
    name: 'Artichokes',
    canDogsEat: 'Yes',
    dogNotes:
      "Artichokes are healthy for dogs and contain vitamin C, folic acid, potassium, niacin, and lots of antioxidants. These vitamins and minerals help prevent illness and support your dog's immune system, muscles, metabolism, and more. Artichokes may also help dogs with irritable bowels.",
    canCatsEat: 'Moderate',
    catNotes: 'Artichokes are not toxic but not beneficial either; high fiber may cause upset stomach; best avoided or offered very small cooked bits without seasoning.',
  },
  {
    name: 'Pomegranate',
    canDogsEat: 'Moderate',
    dogNotes:
      'While pomegranates are not toxic to dogs, they can still make dogs sick. Small quantities of raw pomegranate are not dangerous for your dog, but eating a whole pomegranate can cause stomach upset or gastrointestinal distress.',
    canCatsEat: 'Moderate',
    catNotes: 'Seeds and juice are acidic and high in sugar; non‑toxic but may cause stomach upset or diarrhea in small cats.',
  },
  {
    name: 'Canned Tuna',
    canDogsEat: 'Moderate',
    dogNotes:
      'Eating too much tuna will lead to a build-up of mercury over time, which can then cause long-term health problems. The best kind to offer your pup is tuna canned in spring water.',
    canCatsEat: 'Moderate',
    catNotes: 'Untoxic in small plain amounts but high in mercury—should only be occasional treat; avoid oil or salt‑packed varieties.',
  },
  {
    name: 'Bacon',
    canDogsEat: 'No',
    dogNotes:
      'Bacon is very high in fat and feeding too much can cause stomach upset and more serious health issues like pancreatitis.',
    canCatsEat: 'No',
    catNotes: 'Cured and fatty—too much salt and fat can lead to pancreatitis or sodium poisoning; avoid entirely.',
  },
  {
    name: 'Cabbage',
    canDogsEat: 'Yes',
    dogNotes: 'Cabbage is  safe for dogs, but comes with the same gassy warning!',
    canCatsEat: 'Moderate',
    catNotes: 'Non‑toxic but high in fiber; small cooked pieces might help digestion in rare cases but most cats won’t enjoy it.',
  },
  {
    name: 'Celery',
    canDogsEat: 'Yes',
    dogNotes:
      'Celery is a healthy snack that is safe for your dog if eaten raw, cooked, pureed, or chopped.',
    canCatsEat: 'Moderate',
    catNotes: 'Safe in tiny cooked or soft pieces; high fiber and crunchy texture may upset digestion or pose choking risk.',
  },
  {
    name: 'Chips',
    canDogsEat: 'Moderate',
    dogNotes:
      "They may be fine after a few chips, but these snacks offer no nutritional value and, what's more, they are packed with lots of processed ingredients which can lead to health issues in dogs.",
    canCatsEat: 'No',
    catNotes: 'Processed snack high in salt and fat; completely non‑nutritive and potentially harmful due to sodium and oil.',
  },
  {
    name: 'Coffee',
    canDogsEat: 'No',
    dogNotes:
      'While taking a sip of hot coffee or iced tea probably will not adversely affect most pets, ingestion of one or two caffeine pills can be fatal for small dogs and cats.',
    canCatsEat: 'No',
    catNotes: 'Caffeine is highly toxic to cats—can cause rapid breathing, heart rhythm problems, seizures, even death.'
  },
  {
    name: 'Crab',
    canDogsEat: 'Moderate',
    dogNotes:
      "There is a risk of an allergic reaction to crab meat and it's also high in iodine, a chemical that some dogs may be particularly sensitive to. So, while it's not poisonous, it's best to exercise caution when feeding your dog crab meat.",
    canCatsEat: 'Moderate',
    catNotes: 'Plain cooked crab meat (no shell) is non‑toxic, but high iodine and risk of allergies; offer tiny amounts only.',
  },
  {
    name: 'Avocado',
    canDogsEat: 'No',
    dogNotes:
      'Persin is present in the avocado fruit, pits, leaves, and the actual plant, so all of these parts are potentially poisonous to your dog.',
    canCatsEat: 'Moderate',
    catNotes: 'Avocado flesh is safe in very small amounts, but skin, pit, and leaves contain persin which is toxic; high fat may cause digestive upset.',
  },
  {
    name: 'Curry',
    canDogsEat: 'No',
    dogNotes:
      'Curries are filled with so many different herbs and spices, not to mention they range from quite mild to exceptionally hot. It is these ingredients that can make them very dangerous for your dog to eat.',
    canCatsEat: 'No',
    catNotes: 'Contains spices (garlic, onion, chili) that are toxic to cats and can lead to gastrointestinal and blood‑cell issues.',

  },
  {
    name: 'Cereal',
    canDogsEat: 'Moderate',
    dogNotes:
      "It's very important to avoid cereal with sugar or artificial sweeteners, as these can lead to obesity and diabetes.",
    canCatsEat: 'No',
    catNotes: 'Cereal isn’t toxic, but it’s sugary and not made for cats. It’s best to skip it.',
  },
  {
    name: 'Dates',
    canDogsEat: 'Moderate',
    dogNotes:
      'Dogs can eat dates, but only sparingly due to the high sugar content. You should not feed dates to your dog if he or she suffers from obesity.',
    canCatsEat: 'No',
    catNotes: 'Dates are high in sugar and not good for cats. They can lead to weight gain and stomach problems.',
  },
  {
    name: 'Duck',
    canDogsEat: 'Yes',
    dogNotes: 'Duck is rich in iron and it provides dogs with a lean, easy-to-digest protein source. Duck is also a great source of amino acids, which helps to support strong muscles.',
    canCatsEat: 'Yes',
    catNotes: 'Cats can eat plain cooked duck meat. It’s high in protein and minerals—just remove skin and bones, and skip spices.',
  },
  {
    name: 'Edamame',
    canDogsEat: 'Yes',
    dogNotes: 'Edamame contains fiber, protein, calcium, vitamin C and omega-3. Edamame is soy, which is a common allergy for dogs, so start by only giving your dog a small amount of this name.',
    canCatsEat: 'Moderate',
    catNotes: 'Plain cooked edamame is non‑toxic in tiny amounts, but cats don’t digest plant protein well. Can cause gas or upset stomach.',
  },
  {
    name: 'Sushi',
    canDogsEat: 'Moderate',
    dogNotes: 'Feeding your dog sushi is safe if you follow the feeding guidelines and avoid the ingredients that are not recommended, and do not feed your dog large amounts of raw fish.',
    canCatsEat: 'No',
    catNotes: 'Plain cooked fish in sushi can be safe occasionally, but raw fish and added ingredients like soy sauce or wasabi are not suitable for cats.',
  },
  {
    name: 'Falafel',
    canDogsEat: 'No',
    dogNotes: "Falafel can be toxic to dogs due to the ingredients used. A typical falafel may use ingredients like onion and garlic, both of which are toxic to dogs and will cause serious issues with the dog's red blood cells.",
    canCatsEat: 'No',
    catNotes: 'Falafel contains onion, garlic, spices and legumes—not cat-friendly at all.',
  },
  {
    name: 'Hamburger Meat',
    canDogsEat: 'Yes',
    dogNotes: 'Plain hamburger meat, without added salt or spices, is a healthy source of protein for your dog.',
    canCatsEat: 'Yes',
    catNotes: 'Plain cooked lean beef is fine in small portions—no spices, oil, or added salt.',
  },
  {
    name: 'Hot Dogs',
    canDogsEat: 'No',
    dogNotes: 'Hotdogs are not a good choice for your pooch because they contain so many added ingredients that are not healthy for dogs.',
    canCatsEat: 'No',
    catNotes: "Hot dogs are processed, high in salt, fat and additives—not safe for cats."
  },
  {
    name: 'Hummus',
    canDogsEat: 'No',
    dogNotes: 'Hummus is full of spices and seasonings that, while delicious to you, can harm your dog.',
    canCatsEat: 'No',
    catNotes: "Hummus often has garlic, onion powder and lots of salt—dangerous for cats."
  },
  {
    name: 'Chickpeas',
    canDogsEat: 'Yes',
    dogNotes: 'Chickpeas can be a great source of protein and fibre for your pooch.',
    canCatsEat: 'Moderate',
    catNotes: "Cooked chickpeas are non‑toxic in tiny amounts, but cats don’t digest legumes well and plant protein offers little benefit."
  },
  {
    name: 'Jelly',
    canDogsEat: 'No',
    dogNotes: "Jelly isn't toxic to dogs in itself. It's what's put into the jelly and jam afterwards that can make it dangerous for dogs. Xylitol is a sweetener used in some brands of jelly and jam. It's toxic to dogs.",
    canCatsEat: 'No',
    catNotes: "Jelly may contain xylitol or high sugar and additives. No nutritional value and can be harmful."
  },
  {
    name: 'Jerky',
    canDogsEat: 'Yes',
    dogNotes: "If you're able to find plain jerky, which is plain dried meat for your dog, without the added salt, feel free to give it to your dog. The problem is that today's beef jerky is highly processed and contains ingredients that may harm your dog.  ",
    canCatsEat: 'Moderate',
    catNotes: "Plain, unsalted dried meat is okay occasionally—but many jerky brands have garlic, salt or preservatives that are unsafe."
  },
  {
    name: 'Ketchup',
    canDogsEat: 'No',
    dogNotes: "Large amounts of ketchup are harmful to your dog's health because ketchups have added ingredients—like onion powder, garlic, salt, and sweeteners—that are dangerous to dogs.",
    canCatsEat: 'No',
    catNotes: "Ketchup has onion and garlic powder, sugar and salt—not safe for cats."
  },
  {
    name: 'Mustard',
    canDogsEat: 'No',
    dogNotes: "The seeds of the mustard plant used to make the condiment are toxic to dogs and can cause issues for your pet's digestive system and intestinal tract.",
    canCatsEat: 'No',
    catNotes: "Mustard seeds and condiments are too spicy, salty and contain compounds that can upset or harm cats."
  },
  {
    name: 'Lamb',
    canDogsEat: 'Yes',
    dogNotes: 'Lamb is a great protein option for canines and the ingredient is popping up in many pet-name options. Lamb is packed with essential amino acids and is a good source of dietary fats, which help sustain energy.',
    canCatsEat: 'Yes',
    catNotes: "Plain cooked lamb is a good source of protein. Remove fat and bones, and serve in small portions."

  },
  {
    name: 'Lasagna',
    canDogsEat: 'No',
    dogNotes: 'Lasagna is made specifically for human consumption and not to be eaten by your beloved dog. If ingested in small portions, the effects may not be severe, but this practice is generally discouraged due to the combination of ingredients used to make Lasagna.',
    canCatsEat: 'No',
    catNotes: "Lasagna usually has cheese, garlic, onion, salt and sauce—not safe for cats."
  },
  {
    name: 'Noodles',
    canDogsEat: 'Moderate',
    dogNotes: "Dogs can eat noodles but in moderation. Noodles aren't poisonous to the dogs but it contains a minimal nutritional value.",
    canCatsEat: 'No',
    catNotes: "Plain noodles contain no benefit and may cause digestion issues—cats don’t need carbs."
  },
  {
    name: 'Pizza',
    canDogsEat: 'No',
    dogNotes: "Pizza isn't great for dogs! The base has empty calories, and the sauce and some toppings can be downright toxic.",
    canCatsEat: 'No',
    catNotes: "Pizza has cheese, onion, garlic, spices and high fat—definitely unsafe."
  },
  {
    name: 'Pepperoni',
    canDogsEat: 'No',
    dogNotes: "Pepperoni isn't recommended for your dog as it contains an unhealthy amount of sodium and fat, and it may contain seasonings that are unsafe for dogs. If your dog regularly consumes a large amount of pepperoni, your dog is at risk for digestive issues, salt poisoning, kidney damage, or pancreatitis.",
    canCatsEat: 'No',
    catNotes: "Pepperoni is too fatty and salty, with seasoning that can harm cats—avoid entirely."
  },
  {
    name: 'Pancakes',
    canDogsEat: 'Moderate',
    dogNotes: 'Pancakes for dogs should be plain, with no potentially toxic spices (such as nutmeg) or other ingredients (such as chocolate chips) in them. They should also not have any toppings.',
    canCatsEat: 'No',
    catNotes: "Plain pancakes are safe in theory but high in carbs and often contain butter or milk—not good for cats."
  },
  {
    name: 'Spinach',
    canDogsEat: 'Yes',
    dogNotes: 'Every part of the spinach plant is canDogsEat and non-toxic for your dog.',
    canCatsEat: 'Moderate',
    catNotes: "Spinach isn’t toxic, but it contains oxalates. Small cooked pieces rarely okay—but avoid if your cat has urinary or kidney issues."
  },
  {
    name: 'Toast',
    canDogsEat: 'Yes',
    dogNotes: "Dogs can eat toast as long as they aren't intolerant or allergic to wheat or gluten.",
    canCatsEat: 'Moderate',
    catNotes: "Plain toast small piece can be okay, but no butter or spreads. Mostly carbs—not nutritious for cats."
  },
  {
    name: 'Apples',
    canDogsEat: 'Yes',
    dogNotes: "Apples are low calorie and help freshen your dog's breath, as well as clean teeth. Be sure to remove the core and seeds before giving apples to your dog.",
    canCatsEat: 'Yes',
    catNotes: 'Cats can eat apples in small pieces. Be sure to remove the seeds and core—they’re harmful to cats.'
  },
  {
    name: 'Bananas',
    canDogsEat: 'Yes',
    dogNotes: 'Bananas are a wonderful snack for your dog with many health benefits. Filled with essential vitamins and nutrients, they are tasty as well and most dogs love them!',
    canCatsEat: 'Moderate',
    catNotes: 'Bananas are safe for cats in tiny amounts. They’re high in sugar and not very beneficial.'
  },
  {
    name: 'Coconut',
    canDogsEat: 'Yes',
    dogNotes: 'This quirky fruit has Lauric, which fights off viruses and prevents bad breath, skin irritations, skin allergies and itchiness.',
    canCatsEat: 'Moderate',
    catNotes: 'Coconut isn’t toxic, but it’s high in fat and may cause digestive upset if eaten in large amounts.'
  },
  {
    name: 'Strawberries',
    canDogsEat: 'Yes',
    dogNotes: "Strawberries are full of fiber and vitamin C. Along with that, they also contain an enzyme that can help whiten your dog's teeth as he or she eats them. They contain sugar, so be sure to give them in moderation.",
    canCatsEat: 'Yes',
    catNotes: 'Strawberries are safe in moderation. Too much can cause stomach upset due to the sugar content.'
  },
  {
    name: 'Blueberries',
    canDogsEat: 'Yes',
    dogNotes: "Blueberries are a supername rich in antioxidants, which prevent cell damage in humans and canines alike. They're packed with fiber and phytochemicals as well.",
    canCatsEat: 'Yes',
    catNotes: 'Blueberries are a healthy treat for cats in small amounts. Rich in antioxidants and low in calories.'
  },
  {
    name: 'Kiwi',
    canDogsEat: 'Yes',
    dogNotes: 'Although the inside of the fruit is a safe snack for your dog, you should avoid feeding your pet any portion of the skin. Although it is not toxic, kiwi skin is tough to chew and can possibly pose a choking risk for small dogs and if swallowed whole.',
    canCatsEat: 'Moderate',
    catNotes: 'Cats can eat small pieces of peeled kiwi. The skin is tough and the fruit may cause mild digestive issues.'
  },
  {
    name: 'Watermelon',
    canDogsEat: 'Yes',
    dogNotes: 'Remove the rind before feeding it to your pup.',
    canCatsEat: 'Yes',
    catNotes: 'Cats can eat watermelon in small pieces with no rind or seeds. It’s hydrating but sugary, so keep portions tiny.'
  },
  {
    name: 'Honeydew melon',
    canDogsEat: 'Yes',
    dogNotes: 'Remove the rind before feeding it to your pup.',
    canCatsEat: 'Moderate',
    catNotes: 'Honeydew is non-toxic but high in sugar. Give small bites occasionally, and always without rind or seeds.'
  },
  {
    name: 'Melon',
    canDogsEat: 'Yes',
    dogNotes: 'Remove the rind before feeding it to your pup.',
    canCatsEat: 'Moderate',
    catNotes: 'Melon is okay in small amounts, but offers little nutritional value and may cause soft stool in cats.'

  },
  {
    name: 'Cantaloupe',
    canDogsEat: 'Yes',
    dogNotes: 'Remove the rind before feeding it to your pup.',
    canCatsEat: 'Moderate',
    catNotes: 'Cantaloupe is safe in small bites. Avoid giving rind or seeds—sugar content is high.'
  },
  {
    name: 'Peaches',
    canDogsEat: 'Moderate',
    dogNotes: 'Remove the peach pit before feeding.',
    canCatsEat: 'Moderate',
    catNotes: 'Peach flesh is safe in moderation, but avoid the pit—it contains cyanide and can be deadly.'

  },
  {
    name: 'Pineapple',
    canDogsEat: 'Yes',
    dogNotes: 'This citrus fruit is rich in vitamin C and antioxidants, making it a healthy treat for your dog.',
    canCatsEat: 'Moderate',
    catNotes: 'Pineapple is okay in tiny pieces. It’s acidic and sugary, which can upset a cat’s stomach if overfed.'
  },
  {
    name: 'Broccoli',
    canDogsEat: 'Yes',
    dogNotes: "You can add broccoli to your dog's meal for added protein, calcium, vitamin E, fiber and minerals.",
    canCatsEat: 'Moderate',
    catNotes: 'Broccoli is safe for cats in small amounts. Too much can cause gas or upset their stomach.'
  },
  {
    name: 'Carrots',
    canDogsEat: 'Yes',
    dogNotes: 'This veggie makes great snacks for your dog.',
    canCatsEat: 'Yes',
    catNotes: 'Cats can eat raw or cooked carrots in small amounts. Chop finely to avoid choking and serve plain.'
  },
  {
    name: 'Cookies',
    canDogsEat: 'No',
    dogNotes: "Cookies are high in fat and sugar, and often contain ingredients like chocolate, xylitol, or raisins, which are toxic to dogs.",
    canCatsEat: 'No',
    catNotes: 'Cookies are full of sugar, fat, and sometimes chocolate or xylitol. Never feed them to cats.'
  },
  {
    name: 'Sweet potato',
    canDogsEat: 'Yes',
    dogNotes: "When feeding sweet potatoes to your hound, it's best to peel off the skin first. You can feed it raw, cooked or dehydrated.",
    canCatsEat: 'Yes',
    catNotes: 'Cooked sweet potato is fine in small pieces. Don’t add any seasoning, butter, or sugar.'
  },
  {
    name: 'Pumpkin',
    canDogsEat: 'Yes',
    dogNotes: 'Pumpkin helps aid digestion, if your dog suffers from diarrhea.',
    canCatsEat: 'Yes',
    catNotes: 'Plain pumpkin (not pie filling) helps with constipation and diarrhea in cats.'
  },
  {
    name: 'Green beans',
    canDogsEat: 'Yes',
    dogNotes: 'These veggies are a good low-calorie snack for overweight dogs.',
    canCatsEat: 'Yes',
    catNotes: 'Green beans are safe for cats. They’re low-calorie and can help with fiber intake when cooked and chopped.'
  },
  {
    name: 'Red bell peppers',
    canDogsEat: 'Yes',
    dogNotes: 'Dogs can eat bell peppers. They are safe and they are a healthy alternative snack to share with your dog.',
    canCatsEat: 'Yes',
    catNotes: 'Red bell peppers are fine in tiny amounts. They’re non-toxic and full of vitamins, but not needed in a cat’s diet.'
  },
  {
    name: 'Green bell peppers',
    canDogsEat: 'Yes',
    dogNotes: 'Dogs can eat bell peppers. They are safe and they are a healthy alternative snack to share with your dog.',
    canCatsEat: 'Yes',
    catNotes: 'Green bell peppers are safe in small bites. Some cats may not enjoy the taste—always serve plain.'
  },
  {
    name: 'Tomatoes',
    canDogsEat: 'Moderate',
    dogNotes: "It's okay for your dog to eat tomatoes, but make sure they're completely ripe and remove the stems. Green tomatoes, as well as the leaves and stems contain solanine, which can cause muscle weakness, seizures and digestive upset.",
    canCatsEat: 'Moderate',
    catNotes: 'Cats can eat a little ripe tomato flesh only. Avoid green tomatoes and all leaves or stems—they contain toxins like solanine and may cause serious GI and nerve issues.'
  },
  {
    name: 'Green peas',
    canDogsEat: 'Yes',
    dogNotes: 'Green peas are safe for dogs in small amounts and provide vitamins, fiber, and protein. However, avoid excessive use—especially in grain-free diets—as ongoing research is investigating a possible link between legume-heavy diets and heart issues.',
    canCatsEat: 'Yes',
    catNotes: 'Cats can eat cooked peas in small amounts. They’re non‑toxic and add fiber and vitamins, but feed sparingly since cats don’t need plant protein.'
  },
  {
    name: 'Cucumber',
    canDogsEat: 'Yes',
    dogNotes: 'Cucumbers are a healthy treat for your puppy or dog and are safe for them to eat. Cucumbers are full of goodness! They are very low in salt and sugar and are virtually fat-free. As a result, this crunchy veggie has barely any calories, making it an excellent treat for dogs watching their waistlines.',
    canCatsEat: 'Yes',
    catNotes: 'Cats can eat cucumber slices—low in calories and hydrating. Serve plain, without seeds or skin if your cat may have difficulty chewing.'
  },
  {
    name: 'Asparagus',
    canDogsEat: 'Yes',
    dogNotes: "It is safe to eat, but raw asparagus can cause choking. It also gives your dog's urine an unpleasant odor.",
    canCatsEat: 'Moderate',
    catNotes: 'Cooked asparagus is non‑toxic but fibrous and may be hard to digest. Cats can try tiny bits occasionally, but most won’t enjoy it.'
  },
  {
    name: 'Potatoes',
    canDogsEat: 'Yes',
    dogNotes: 'Raw and green potatoes are toxic for dogs, but cooked potatoes are nutritious.',
    canCatsEat: 'Moderate',
    catNotes: 'Cooked plain potato is safe rarely—for cats it’s starchy and offers no real benefit. Avoid green or raw potatoes entirely.'
  },
  {
    name: 'Corn',
    canDogsEat: 'Moderate',
    dogNotes: 'It is perfectly safe for you to feed your dog corn off the cob in small amounts. Just make sure that you do so in moderation.',
    canCatsEat: 'Yes',
    catNotes: 'Cats can have small cooked corn kernels as an occasional treat. Non‑toxic but low value nutritionally and may cause mild digestive upset.'
  },
  {
    name: 'Rice',
    canDogsEat: 'Yes',
    dogNotes: 'Vets will recommend a bland diet of white rice (with no seasonings or fats) and boiled chicken for dogs with gastrointestinal issues. White rice is easy to digest and helps their digestive system relax and regain its balance so your dog can eat their regular kibble again.',
    canCatsEat: 'Moderate',
    catNotes: 'Plain cooked rice is safe but not necessary for cats. It’s bland filler and may upset sensitive digestion; offer only in tiny amounts if needed.'
  },
  {
    name: 'Oats',
    canDogsEat: 'Yes',
    dogNotes: "It is a great alternative carbohydrate for dogs that may be sensitive to wheat or grains. Oats contains vitamin B, which helps maintain a healthy coat, and linoleic acid, which is a type of omega-6 fatty acid that helps to keep a dog's skin strong and healthy.",
    canCatsEat: 'Yes',
    catNotes: 'Plain cooked oats are non‑toxic and offer fiber. They’re safe in small amounts but not essential for cats.'
  },
  {
    name: 'Oatmeal',
    canDogsEat: 'Yes',
    dogNotes: "It is a great alternative carbohydrate for dogs that may be sensitive to wheat or grains. Oatmeal contains vitamin B, which helps maintain a healthy coat, and linoleic acid, which is a type of omega-6 fatty acid that helps to keep a dog's skin strong and healthy.",
    canCatsEat: 'Yes',
    catNotes: 'Plain oatmeal is safe in tiny portions—no milk or sugar added. It provides fiber but little benefit for obligate carnivores.'
  },
  {
    name: 'Popcorn',
    canDogsEat: 'Yes',
    dogNotes: "Popcorn is fine as long as it's not salted or buttered.",
    canCatsEat: 'Moderate',
    catNotes: 'Air‑popped plain popcorn kernels are OK in very small amounts. Avoid butter, salt or flavored varieties.'
  },
  {
    name: 'Quinoa',
    canDogsEat: 'Yes',
    dogNotes: 'Quinoa is safe and sometimes included in high-quality dog food. While not essential in a canine diet, it offers plant-based protein and fiber. Serve it plain and fully cooked, without seasonings or oils.',
    canCatsEat: 'Moderate',
    catNotes: 'Cooked quinoa is safe in small bites, but cats don’t digest plant protein well. Best when mixed with meat in tiny quantities.'
  },
  {
    name: 'Cheese',
    canDogsEat: 'Yes',
    dogNotes: 'If you do decide to give your dog cheese, feed low fat types like mozzarella or cottage cheese.',
    canCatsEat: 'Moderate',
    catNotes: 'Plain low‑fat cheeses are usually safe in very small bits. Many cats are lactose intolerant—watch for stomach upset.'
  },
  {
    name: 'Yogurt',
    canDogsEat: 'Moderate',
    dogNotes: 'Always feed your dog unsweetened, plain yogurt, if they tolerate dairy products.',
    canCatsEat: 'Moderate',
    catNotes: 'Plain unsweetened yogurt can be given sparingly. Lactose in dairy might upset some cats; avoid sweetened or flavored types.'
  },
  {
    name: 'Goat Milk',
    canDogsEat: 'Moderate',
    dogNotes: 'Goat milk is easier to digest than cow’s milk and contains beneficial nutrients, but it’s still a dairy product. Some dogs are lactose intolerant, so introduce it slowly and in small amounts to avoid stomach upset.',
    canCatsEat: 'Moderate',
    catNotes: 'Some cats can tolerate small amounts of goat milk; still many adult cats are lactose intolerant—monitor closely.'
  },
  {
    name: 'Peanuts',
    canDogsEat: 'Yes',
    dogNotes: 'This heart-healthy nut is great for your hound.',
    canCatsEat: 'Moderate',
    catNotes: 'Plain unsalted peanuts are non‑toxic but high in fat. Only offer in finely chopped form and very rarely.'
  },
  {
    name: 'Peanut butter',
    canDogsEat: 'Yes',
    dogNotes: 'Peanut butter can be used as a healthy treat. However, make sure it is natural and free from xylitol and excess sugar/salt.',
    canCatsEat: 'Moderate',
    catNotes: 'A tiny smear of natural peanut butter (without xylitol) is safe rarely—but most cats dislike the texture and it adds unnecessary fat.'
  },
  {
    name: 'Cashews',
    canDogsEat: 'Moderate',
    dogNotes: "Dogs can safely eat cashews, as long as they are shelled, unsalted, and they aren't mixed with other nuts.",
    canCatsEat: 'Moderate',
    catNotes: 'Unsalted, shelled cashews are non‑toxic in small bits. Very high fat and rarely appealing for cats.'
  },
  {
    name: 'Eggs',
    canDogsEat: 'Yes',
    dogNotes: 'Cooked eggs soothe upset stomachs.',
    canCatsEat: 'Yes',
    catNotes: 'Fully cooked egg is safe and good protein for cats—serve plain, with no seasoning.'
  },
  {
    name: 'Fish',
    canDogsEat: 'Yes',
    dogNotes: 'Two of the most beneficial fish for dogs are sardines and salmon.',
    canCatsEat: 'Yes',
    catNotes: 'Cooked fish like salmon or sardines is safe for cats in small portions (without bones). Limit frequency due to fat and mercury.'
  },
  {
    name: 'Shrimp',
    canDogsEat: 'Yes',
    dogNotes: 'Remove the shells and tails off the shrimp.',
    canCatsEat: 'Yes',
    catNotes: 'Plain cooked shrimp (shell and tail removed) is safe and lean. Offer small pieces occasionally.'
  },
  {
    name: 'Lobster',
    canDogsEat: 'Yes',
    dogNotes: 'Remove the shell off the lobster.',
    canCatsEat: 'Moderate',
    catNotes: 'Cooked lobster meat (no shell) is non‑toxic but high in sodium and iodine—safe very sparingly if plain.'
  },
  {
    name: 'Lean Meats',
    canDogsEat: 'Yes',
    dogNotes: 'Most dogs are fine eating lean cuts of meat that have been cooked well. Take off all visible fat -- including the skin on poultry. Be sure that there are no bones in the meat before you give it to your dog.',
    canCatsEat: 'Yes',
    catNotes: 'Plain cooked lean meat (chicken, beef, turkey) is ideal for cats. Remove fat, bones, and seasonings.'
  },
  {
    name: 'Soybeans',
    canDogsEat: 'Yes',
    dogNotes: "Dogs can consume soy as long as they don't have a diagnosed soy allergy. Some dogs don't tolerate soy very well.",
    canCatsEat: 'Moderate',
    catNotes: 'Cooked plain soybeans are safe in tiny amounts. Plant protein offers little benefit and may cause digestive issues.'
  },
  {
    name: 'Honey',
    canDogsEat: 'Moderate',
    dogNotes: "Honey is safe for dogs to eat in small quantities. It contains natural sugars and small amounts of vitamins and minerals. The high sugar content of honey can lead to obesity in dogs if owners feed too much honey and do not provide adequate exercise balanced nutrition. Sugars can also cause tooth decay, so it might be a good idea to brush your dog's teeth if you do feed him honey.",
    canCatsEat: 'No',
    catNotes: 'A dollop of honey is non‑toxic but offers no nutritional value for cats. High in sugar—best avoided or kept very small.'
  },
  {
    name: 'Bread',
    canDogsEat: 'Moderate',
    dogNotes: 'Plain bread with no added ingredients is not toxic to dogs. However, it offers them no nutritional value. Because of that, we should think of bread as an occasional treat instead of a diet staple.',
    canCatsEat: 'Moderate',
    catNotes: 'Plain bread is non‑toxic in tiny amounts—but it’s mostly carbs and no benefit. Avoid if your cat has gluten intolerance.'
  },
  {
    name: 'Ham',
    canDogsEat: 'Moderate',
    dogNotes: "Cooked ham by itself isn't the healthiest treat for your dog, but it should not pose any problems for them when eaten occasionally in small amounts.",
    canCatsEat: 'Moderate',
    catNotes: 'Small pieces of cooked ham are non‑toxic but high in salt and fat—ok rarely, but not recommended as a treat.'
  },
  {
    name: 'Milk',
    canDogsEat: 'Moderate',
    dogNotes: "Milk is a safe treat in small quantities. A few tablespoons of cow's milk or goat's milk on an occasional basis can be a nice reward for your dog without the side effects of overindulgence.",
    canCatsEat: 'Moderate',
    catNotes: 'Most adult cats are lactose intolerant—small lactose‑free milk or goat’s milk may be tolerated occasionally.'
  },
  {
    name: 'Ice cream',
    canDogsEat: 'No',
    dogNotes: 'Ice cream is not healthy for dogs. It contains high sugar and lactose levels, which can cause digestive issues and long-term health problems like obesity and diabetes. Instead, consider dog-safe frozen treats like plain frozen yogurt or fruit-based sorbets.',
    canCatsEat: 'No',
    catNotes: 'Ice cream is high in sugar and lactose—likely to cause diarrhea or worse in cats. Avoid entirely.'
  },
  {
    name: 'Chocolate',
    canDogsEat: 'No',
    dogNotes: 'Even if your dog eats a small piece of chocolate, especially dark chocolate, he/she could start vomiting and suffer from diarrhea.',
    canCatsEat: 'No',
    catNotes: 'Chocolate is highly  toxic to cats. It contains theobromine and caffeine, which can cause vomiting, seizures, and even death.'
  },
  {
    name: 'Xylitol',
    canDogsEat: 'No',
    dogNotes: "Some pet owners think that sugar-free means healthy, but this isn't true for your dog. Xylitol is a common sugar-free ingredient for humans but is highly toxic to dogs.",
    canCatsEat: 'No',
    catNotes: 'Xylitol is extremely dangerous for cats. It can trigger hypoglycemia and liver failure even in tiny amounts.'
  },
  {
    name: 'Grapes',
    canDogsEat: 'No',
    dogNotes: 'These seemingly harmless fruits can cause kidney failure in your dog.',
    canCatsEat: 'No',
    catNotes: 'Grapes are toxic to cats and can potentially cause kidney failure.',
  },
  {
    name: 'Raisins',
    canDogsEat: 'No',
    dogNotes: 'These seemingly harmless fruits can cause kidney failure in your dog.',
    canCatsEat: 'No',
    catNotes: 'Raisins are toxic to cats and may cause kidney damage or failure.',
  },
  {
    name: 'Currants',
    canDogsEat: 'No',
    dogNotes: 'These seemingly harmless fruits can cause kidney failure in your dog.',
    canCatsEat: 'No',
    catNotes: 'Currants are toxic and can cause serious kidney problems in cats.',

  },
  {
    name: 'Cinnamon',
    canDogsEat: 'Moderate',
    dogNotes: "Cinnamon isn't toxic for dogs but large amounts of cinnamon can cause vomiting, diarrhea, and other digestive issues in your dog.",
    canCatsEat: 'No',
    catNotes: "Small amounts are usually tolerated, but too much can irritate the mouth or cause liver toxicity.",
  },
  {
    name: 'Raw potatoes',
    canDogsEat: 'No',
    dogNotes: 'Never give your dog raw potatoes because they contain solanine, which is toxic to dogs.',
    canCatsEat: 'No',
    catNotes: "Raw potatoes contain solanine and are toxic. Cooked, plain potato is safer but offers little benefit.",
  },
  {
    name: 'Onions',
    canDogsEat: 'No',
    dogNotes: 'All onions – white, yellow, green – can cause onion toxicosis in your dog. Whether they are cooked or raw, all parts of the onion, including the leaves, flesh, skin, and juice, are dangerous for your dog. ',
    canCatsEat: 'No',
    catNotes: "Onions are very toxic to cats and can destroy red blood cells even in small amounts.",
  },
  {
    name: 'Garlic',
    canDogsEat: 'No',
    dogNotes: 'Garlic is toxic to dogs. Toxic doses of garlic can cause damage to the red blood cells leading to anemia. GI upset can also occur.',
    canCatsEat: 'No',
    catNotes: "Garlic is toxic and can cause vomiting, diarrhea, and anemia in cats.",
  },
  {
    name: 'Chives',
    canDogsEat: 'No',
    dogNotes: 'Chives belong to the Allium family (which also includes onion, garlic, and leeks) and are poisonous to dogs and cats.',
    canCatsEat: 'No',
    catNotes: "Chives are highly toxic to cats and may cause severe damage to red blood cells.",
  },
  {
    name: 'Macadamia nuts',
    canDogsEat: 'No',
    dogNotes: 'Macadamia nuts are toxic to dogs. Your pup would only need to eat a small amount of it to experience negative results.',
    canCatsEat: 'No',
    catNotes: "Macadamia nuts are toxic to cats and can cause weakness, vomiting, and tremors.",
  },
  {
    name: 'Pecans',
    canDogsEat: 'No',
    dogNotes: "Dogs cannot eat pecans safely. If they happen to eat one or two, it's unlikely they will suffer any adverse effects. However, eating pecans containing toxic mold can be harmful to your pup.",
    canCatsEat: 'No',
    catNotes: "Pecans are not safe for cats. They can cause digestive upset and may carry mold toxins.",
  },
  {
    name: 'Walnuts',
    canDogsEat: 'Moderate',
    dogNotes: "Assuming they don't contain any black mold, plain, store-bought walnuts themselves aren't necessarily toxic to your dog in small quantities.Walnuts that have been collected outdoors from trees aren't safe for pets.",
    canCatsEat: 'No',
    catNotes: "Walnuts are difficult to digest and may contain mold. Best avoided for cats.",
  },
  {
    name: 'Almonds',
    canDogsEat: 'No',
    dogNotes: "Although almonds aren't toxic, they can cause choking and damage your dog's windpipe.",
    canCatsEat: 'No',
    catNotes: "Cats should not eat almonds due to choking risks and high fat content.",
  },
  {
    name: 'Nutmeg',
    canDogsEat: 'No',
    dogNotes: 'Nutmeg is toxic for dogs, and dogs should never eat it. Nutmeg poisoning can cause disorientation, high heart rate, seizures, and hallucinations in dogs.',
    canCatsEat: 'No',
    catNotes: "Nutmeg is toxic to cats and can affect the nervous system.",
  },
  {
    name: 'Sugar',
    canDogsEat: 'No',
    dogNotes: 'Added sugar can cause diabetes and weight gain in your hound.',
    canCatsEat: 'No',
    catNotes: "Added sugar provides no benefit and may cause obesity or diabetes in cats.",
  },
  {
    name: 'Fatty Food',
    canDogsEat: 'No',
    dogNotes: "Feeding your dog fatty foods, like hot dogs, bacon, ribs, or fried chicken, can upset your dog's stomach and cause vomiting and diarrhea. It can also lead to pancreatitis, which is an inflammation of the pancreas.",
    canCatsEat: 'No',
    catNotes: "Cats struggle to digest fatty foods. They may develop pancreatitis or digestive issues.",
  },
  {
    name: 'Fried Food',
    canDogsEat: 'No',
    dogNotes: "foods that are overly fatty, such as fried chicken, are very toxic for dogs, says Hartogensis. If they eat enough, such foods can cause inflammation of the pancreas, causing that organ to produce enzymes that can severely damage your pet's intestines.",
    canCatsEat: 'No',
    catNotes: "Fried foods are not suitable for cats and can lead to obesity or GI distress.",
  },
  {
    name: 'Mushrooms',
    canDogsEat: 'No',
    dogNotes: 'tore-bought mushrooms are generally non-toxic but offer little benefit and may cause GI upset. Never feed wild mushrooms.',
    canCatsEat: 'No',
    catNotes: "Store-bought mushrooms in small cooked amounts are not toxic but not recommended.",
  },
  {
    name: 'Ethanol',
    canDogsEat: 'No',
    dogNotes: 'Ethanol poisoning is seen frequently in dogs, and occurs due to exposure to dyes, inks, disinfectants, mouthwashes, paints, perfumes, pharmaceuticals, gasoline, and certain beverages.',
    canCatsEat: 'No',
    catNotes: "Ethanol is highly toxic to cats. Ingestion or exposure can be fatal.",
  },
  {
    name: 'Alcohol',
    canDogsEat: 'No',
    dogNotes: 'Alcohol is highly toxic to dogs. Even small amounts of alcohol — not only in drinks but also in syrups and raw bread dough — can have ingredients that are poisonous for them.',
    canCatsEat: 'No',
    catNotes: "Alcohol is very toxic to cats and even small amounts can cause severe poisoning.",
  },
  {
    name: 'Cooked Bones',
    canDogsEat: 'No',
    dogNotes: 'They become brittle and easily break into sharp shards that can do a lot of damage when they pass through the gastrointestinal tract.',
    canCatsEat: 'No',
    catNotes: "Cooked bones are dangerous for cats and may cause choking or internal injury.",
  },
  {
    name: 'Bread dough',
    canDogsEat: 'No',
    dogNotes: "Raw bread dough that is made with yeast can be an unexpected poisoning hazard for dogs. When the bread dough is eaten, the gastrointestinal tract provides an ideal environment for the yeast organisms to proliferate. The mass of bread dough will expand in the dog's stomach, pressing on the surrounding organs and causing respiratory difficulty. Dogs may attempt to vomit up the bread dough, but the glutinous nature of the mass will make this difficult. As the condition progresses, the fermenting yeast cells will produce ethanol and the dog's blood alcohol level will rise to toxic levels. Like other forms of alcohol poisoning, unbaked bread dough can cause inebriation, lack of coordination, and central nervous system depression.",
    canCatsEat: 'No',
    catNotes: "Yeast in bread dough expands in the stomach and can lead to bloating and alcohol toxicity in cats.",
  },
  {
    name: 'Mango',
    canDogsEat: 'Yes',
    dogNotes: "Mangoes are safe and healthy for most dogs, as long as they don't have diabetes",
    canCatsEat: 'Moderate',
    catNotes: "Peeled mango without the pit can be given in small amounts. High in sugar and fiber, so only occasionally.",
  },
  {
    name: 'Papaya',
    canDogsEat: 'Yes',
    dogNotes: "Papaya is safe for dogs to eat. In fact, it's even a healthy treat for dogs when fed in moderation. There are several nutritional benefits of papaya that apply to dogs as well as humans. Like many other fruits, papaya is rich in vitamins A and C, as well as potassium and fiber.",
    canCatsEat: 'Moderate',
    catNotes: 'Papaya is not toxic to cats but may cause digestive upset. Offer only small, plain pieces occasionally.',
  },
  {
    name: 'Cranberries',
    canDogsEat: 'Moderate',
    dogNotes: 'Cranberries are not toxic or poisonous to dogs. You can feed cranberries to your pup fresh or dried, but they do need to be given in small portions, in moderation, stem-free, and completely plain.',
    canCatsEat: 'Moderate',
    catNotes: 'Cranberries are safe in small portions. Too many may upset digestion or cause urinary issues in some cats.',
  },
  {
    name: 'Chewing Gum',
    canDogsEat: 'No',
    dogNotes: 'One piece of chewing gum typically contains about 0.22 – 1.0 grams of xylitol on average. This means that a single piece of gum can easily poison a 10-pound dog.',
    canCatsEat: 'No',
    catNotes: 'Chewing gum may contain xylitol or other ingredients toxic to cats. Ingestion requires emergency care.',
  },
  {
    name: 'Raw Bones',
    canDogsEat: 'Moderate',
    dogNotes: 'Choose bones that are larger than the dog’s mouth to prevent choking. Raw bones must be fresh to avoid bacterial contamination (e.g., salmonella or E. coli). Most importantly, never leave your dog unattended while chewing a bone.',
    canCatsEat: 'Moderate',
    catNotes: 'Raw bones can be given under close supervision. They must be large and fresh to avoid injury or infection.',
  },
  {
    name: 'Pasta',
    canDogsEat: 'Moderate',
    dogNotes: 'Plain pasta (no sauces) is safe for dogs in moderation.',
    canCatsEat: 'Moderate',
    catNotes: 'Plain pasta is not toxic to cats, but it offers no benefits and may contribute to weight gain.',
  },
  {
    name: 'Steak',
    canDogsEat: 'Moderate',
    dogNotes: 'Dogs can eat steak, it is an excellent protein source! However, given its richness it should be seen as more of a treat than an everyday meal. Be sure it is lean, cooked (either pan-fried or grilled), and served plain without salt, spices, butter or seasoning.',
    canCatsEat: 'Yes',
    catNotes: 'Cooked, unseasoned steak is safe for cats and provides quality protein in moderation.',
  },
  {
    name: 'Chicken',
    canDogsEat: 'Yes',
    dogNotes: 'Cooked chicken is a healthy food that is safe for most dogs to eat. Chicken is one of the most common ingredients used in dog foods, as it is an excellent source of protein, which your dog needs to stay healthy.',
    canCatsEat: 'Yes',
    catNotes: 'Cooked chicken is safe and beneficial for cats as a protein source when plain and boneless.',
  },
  {
    name: 'Raw Meat',
    canDogsEat: 'No',
    dogNotes: 'The American Veterinary Medical Association cautions against feeding your dog a raw meat diet, warning that it does not provide the balanced nutrition your canine companion needs. Eating raw meat regularly can increase the risk of nutritional deficiencies.',
    canCatsEat: 'Moderate',
    catNotes: 'Some cats tolerate raw diets, but risks include bacterial infection. Should only be fed if properly prepared under veterinary guidance.',
  },
  {
    name: 'Raw Chicken',
    canDogsEat: 'No',
    dogNotes: 'Raw chicken can contain harmful bacteria, such as salmonella, which can make your dog sick.',
    canCatsEat: 'Moderate',
    catNotes: 'Some raw-fed cats eat raw chicken, but there’s a risk of salmonella. Only feed under strict hygiene and veterinary advice.',
  },
  {
    name: 'Raw Fish',
    canDogsEat: 'No',
    dogNotes: 'Raw fish is bad for dogs to eat. Serving raw fish is an unnecessary risk to take. Left uncooked, fish can contain bacteria like salmonella or certain parasites.',
    canCatsEat: 'Moderate',
    catNotes: 'Occasionally tolerated in raw diets, but raw fish may carry parasites or thiaminase. Should only be offered with care and supervision.',
  },
  {
    name: 'Beetroots',
    canDogsEat: 'Yes',
    dogNotes: 'Beetroots get a big thumbs up as a healthy snack for dogs - they are packed full of fibre, vitamins and antioxidants.',
    canCatsEat: 'Moderate',
    catNotes: 'Beets are not toxic but may cause stomach upset. Serve cooked and plain in small amounts only.',
  },

  {
    name: 'Rocca Leaves (Arugula)',
    canDogsEat: 'Yes',
    dogNotes: 'Like many leafy green vegetables, arugula does not contain anything toxic to dogs, making it a low-calorie snack.',
    canCatsEat: 'Yes',
    catNotes: 'Arugula is safe for cats and may aid digestion when given in small, plain amounts.',
  },
  {
    name: 'Eggplant',
    canDogsEat: 'Yes',
    dogNotes: 'Eggplant is rich in fiber and antioxidants. A small amount of plain, cooked eggplant is fine to share with your pooch and can even be a good way to boost their fiber intake.',
    canCatsEat: 'Moderate',
    catNotes: 'Cooked eggplant is safe in small portions. Raw or seasoned versions may cause irritation.',
  },
  {
    name: 'Zucchini',
    canDogsEat: 'Yes',
    dogNotes: 'It is perfectly safe for dogs and puppies. In fact, it may be one of the best vegetables to feed dogs. Zucchini can be given to dogs raw or cooked, and they can eat the fruit or flowers.',
    canCatsEat: 'Yes',
    catNotes: 'Zucchini is safe and can be given raw or cooked in small amounts.',
  },
  {
    name: 'Greengage',
    canDogsEat: 'No',
    dogNotes: 'Greengage is toxic to dogs, causing serious health issues if ingested',
    canCatsEat: 'No',
    catNotes: 'Greengages can be harmful to cats due to potential toxins in the skin and pit.',
  },
  {
    name: 'Chestnuts',
    canDogsEat: 'Moderate',
    dogNotes: 'Dogs can eat chestnuts in moderation. Chestnuts are non-toxic to dogs and can even provide some nutritional benefits, like vitamins, minerals, and fiber. Be cautious not to confuse canDogsEat chestnuts with horse chestnuts, which are toxic to dogs and should never be consumed.',
    canCatsEat: 'Moderate',
    catNotes: 'Plain edible chestnuts can be given in very small amounts. Horse chestnuts are toxic and must be avoided.',
  },
  {
    name: 'Figs',
    canDogsEat: 'Moderate',
    dogNotes: 'Figs are high in natural sugars, which can lead to weight gain or upset stomachs if fed in excess.',
    canCatsEat: 'Moderate',
    catNotes: 'Figs are not toxic but may cause diarrhea or mouth irritation in some cats. Limit to tiny portions.',
  },
  {
    name: 'Pistachios',
    canDogsEat: 'No',
    dogNotes: 'While pistachios are not toxic to dogs and highly unlikely to be fatal if eaten, it is still best to prevent your dog from eating them.',
    canCatsEat: 'No',
    catNotes: 'Pistachios are not toxic but are high in fat and salt. They can lead to digestive upset or pancreatitis in cats.'
  },
  {
    name: 'Cherries',
    canDogsEat: 'No',
    dogNotes: 'The main danger of cherries is that their pits, stems, and leaves contain cyanide, which is poisonous and potentially lethal if consumed in high enough quantities. Cherry pits can also get lodged in a dog’s digestive tract and cause intestinal blockages.',
    canCatsEat: 'No',
    catNotes: 'Cherries contain cyanide in pits, stems, and leaves, which is toxic to cats. It can also cause stomach issues.'
  },
  {
    name: 'Guava',
    canDogsEat: 'Moderate',
    dogNotes: 'Dogs can eat guava in small portions as an occasional treat. The fruit offers several health benefits, but if eaten in excess, the high amount of sugar can lead to weight gain.',
    canCatsEat: 'Moderate',
    catNotes: 'Safe occasionally. Too much sugar can cause digestive issues. Seeds and skin should be removed.'
  },
  {
    name: 'Salt',
    canDogsEat: 'Moderate',
    dogNotes: 'Dogs can eat salt, but too much can cause salt toxicity. Just like people, dogs need a certain amount of salt in their daily diet.',
    canCatsEat: 'Moderate',
    catNotes: 'Cats require only trace amounts of salt. Excess salt can cause dehydration and toxicity.'
  },
  {
    name: 'Olives',
    canDogsEat: 'Moderate',
    dogNotes: 'Dogs can eat olives in moderation. Plain, unsalted olives can be a healthy snack for your pup.',
    canCatsEat: 'Moderate',
    catNotes: 'Plain, pitted olives are not toxic to cats but should be given rarely due to salt and fat content.'
  },
  {
    name: 'Acai Berry',
    canDogsEat: 'No',
    dogNotes: 'The fruit contains theobromine, the same ingredient in dark chocolate that causes chocolate poisoning.',
    canCatsEat: 'No',
    catNotes: 'Acai contains theobromine, which is toxic to cats and can cause vomiting, tremors, or seizures.'
  },
  {
    name: 'Pears',
    canDogsEat: 'Yes',
    dogNotes: 'Pears are a great snack because they are high in copper, vitamins C and K, and fiber.',
    canCatsEat: 'Moderate',
    catNotes: 'Cats can eat small amounts of pear flesh. Seeds and core must be removed due to cyanide content.'
  },
  {
    name: 'Lettuce',
    canDogsEat: 'Yes',
    dogNotes: 'Lettuce is considered a low-calorie snack and a great training treat for overweight dogs, or those on a low-calorie diet.',
    canCatsEat: 'Yes',
    catNotes: 'Safe for cats to nibble on. Offers fiber and moisture but limited nutritional value.'
  },
  {
    name: 'Cauliflower',
    canDogsEat: 'Yes',
    dogNotes: 'Cauliflower is completely safe and nontoxic to dogs.',
    canCatsEat: 'Yes',
    catNotes: 'Safe for cats in small amounts. Can be given steamed or boiled without spices.'
  },
  {
    name: 'Kale',
    canDogsEat: 'Yes',
    dogNotes: 'Raw, uncooked kale is fine for dogs to eat, but steaming or blanching it may make it easier for them to digest.',
    canCatsEat: 'Moderate',
    catNotes: 'Small portions are safe. Large amounts may cause GI upset or affect calcium balance.'
  },
  {
    name: 'Radish',
    canDogsEat: 'Yes',
    dogNotes: 'The crunchy vegetable is safe for dogs. However, two plants that bear the name “radish”—horseradish and wild radishes—aren nott actual radishes and are not safe for dogs to eat.',
    canCatsEat: 'Moderate',
    catNotes: 'Radishes are not toxic to cats but may cause stomach upset or disinterest. Best offered rarely and in small portions.'
  },
  {
    name: 'Apricot',
    canDogsEat: 'Yes',
    dogNotes: 'Consuming apricots in moderation is safe and healthy for dogs, offering a series of potential health benefits such as improved digestion and lowered blood pressure.',
    canCatsEat: 'Moderate',
    catNotes: 'Apricot flesh is safe in tiny amounts. Pit and leaves must be avoided due to cyanide risk.'
  },
  {
    name: 'Passion Fruit',
    canDogsEat: 'No',
    dogNotes: 'The rind and seeds can be a choking hazard for your dog and could cause blockages the digestive system. The seeds, if chewed thoroughly enough can release cyanide. Cyanide poisoning can lead to serious health issues with symptoms like diarrhoea and vomiting.',
    canCatsEat: 'No',
    catNotes: 'Passion fruit is toxic to cats. Seeds and rind can cause cyanide poisoning and GI distress.'
  },
  {
    name: 'Grapefruit',
    canDogsEat: 'No',
    dogNotes: 'The grapefruit is a citrusy fruit that many people enjoy eating.  This is one fruit you should not share with your dog as it is toxic to him.  If you suspect your dog ingested any piece of a grapefruit, the flesh, the seeds, or the peel, contact your veterinarian immediately.',
    canCatsEat: 'No',
    catNotes: 'Toxic to cats. Can cause drooling, vomiting, and sensitivity to light due to psoralens and citric acid.'
  },
  {
    name: 'Olive Oil',
    canDogsEat: 'Moderate',
    dogNotes: 'Most dogs can safely eat olive oil in small quantities. However, the right serving size for your dog will depend on their size. The maximum amount of olive oil you can give a small or medium dog is a quarter of a teaspoon per day.',
    canCatsEat: 'Moderate',
    catNotes: 'Safe in moderation. May help with dry skin or constipation but should not be overused.'
  },

  {
    name: 'Raspberries',
    canDogsEat: 'Moderate',
    dogNotes: 'Contain antioxidants and fiber. Safe in small amounts, but they have trace xylitol, which can be harmful in excess.',
    canCatsEat: 'Moderate',
    catNotes: 'Safe in very small portions. High sugar and trace xylitol make them unsuitable for frequent feeding.'
  },

  {
    name: 'Turkey',
    canDogsEat: 'Yes',
    dogNotes: 'They can eat plain, unseasoned pieces of turkey meat like turkey breast & turkey thighs. Avoid bones, skin, and processed turkey.',
    canCatsEat: 'Yes',
    catNotes: 'Cats can eat plain, cooked turkey in small portions. Avoid bones, skin, and seasoning, especially onions or garlic.'
  },

  {
    name: 'Raw Eggs',
    canDogsEat: 'No',
    dogNotes: 'While raw eggs are not technically toxic, they can contain bacteria like E coli and salmonella, which can cause food poisoning.',
    canCatsEat: 'No',
    catNotes: 'Raw eggs may contain salmonella or E. coli and also have avidin, which blocks biotin absorption. Cooked egg is safer.'
  },
  {
    name: 'Tea',
    canDogsEat: 'No',
    dogNotes: 'Dogs cannot drink tea due to its caffeine content. Caffeine is toxic to dogs and can cause many health issues – even decaffeinated tea contains small amounts of caffeine so it is still not recommended.',
    canCatsEat: 'No',
    catNotes: 'Tea contains caffeine, which is highly toxic to cats. Even small amounts can cause heart palpitations, tremors, and seizures.'
  },
  {
    name: 'Sausages',
    canDogsEat: 'No',
    dogNotes: 'Sausages and cooked manufactured meats should be avoided as they can contain sulphite preservatives – these can cause thiamine (Vitamin B1) deficiency, which can be fatal. Sausages are also often too fatty and salty.',
    canCatsEat: 'No',
    catNotes: 'Sausages are too high in fat, salt, and preservatives for cats. They may also contain onions or garlic, which are toxic.'
  },
  {
    name: 'Soft Drinks',
    canDogsEat: 'No',
    dogNotes: 'With soft drinks, you both run the risk of ramping up your dogs blood sugar and giving your pet accidental caffeine poisoning.',
    canCatsEat: 'No',
    catNotes: 'Soft drinks contain caffeine and sugar, both dangerous for cats. Even small sips can cause restlessness, vomiting, or worse.'
  },
  {
    name: 'Brown Rice',
    canDogsEat: 'Yes',
    dogNotes: 'It is an easily digestible carbohydrate source and provides beneficial minerals and B vitamins. When reading dog food labels, you may see brown rice as a common ingredient  because it is so nutritious.',
    canCatsEat: 'Moderate',
    catNotes: 'Cooked brown rice can be okay in small amounts for cats, but it is not necessary in their carnivorous diet.'
  },
  {
    name: 'Mayonnaise',
    canDogsEat: 'No',
    dogNotes: 'While mayo is not toxic, it is high in fat and is not a healthy choice to feed your dog.',
    canCatsEat: 'No',
    catNotes: 'Mayonnaise is not toxic to cats but is very fatty and offers no nutritional benefit. It may lead to digestive upset or weight gain.'
  },
  {
    name: 'Butter',
    canDogsEat: 'No',
    dogNotes: 'Eating treats and snacks that contain butter can hurt your dog and cause serious problems like pancreatitis.',
    canCatsEat: 'No',
    catNotes: 'Butter is high in fat and not suitable for cats. It can lead to vomiting, diarrhea, or pancreatitis if consumed regularly.'
  },
  {
    name: 'Fast Food',
    canDogsEat: 'No',
    dogNotes: 'Excessive salt intake can lead to sodium toxicity in dogs, causing increased thirst, urination, high blood pressure, organ damage, and a higher risk of pancreatitis, so it is best to avoid feeding them high-sodium junk foods like fries, pizza, and burgers.',
    canCatsEat: 'No',
    catNotes: 'Fast food contains too much salt, fat, and spices for cats. It can cause digestive issues and long-term health risks.'
  },
  {
    name: 'Soy Sauce',
    canDogsEat: 'No',
    dogNotes: 'while soy is OK for dogs, soy sauce would not be! Soy sauce is very high in salt and would be harmful for a dog.',
    canCatsEat: 'No',
    catNotes: 'Soy sauce is extremely salty and can cause salt poisoning in cats. Even a teaspoon is too much.'
  },
  {
    name: 'Lime',
    canDogsEat: 'No',
    dogNotes: 'Limes are not safe for canine consumption. All parts of these green sour citrus fruits are toxic to dogs and can cause lime poisoning.',
    canCatsEat: 'No',
    catNotes: 'Limes contain essential oils and psoralens that are toxic to cats. Can cause vomiting, depression, and photosensitivity.'
  },
  {
    name: 'Plum',
    canDogsEat: 'Moderate',
    dogNotes: 'Dogs can eat plums, but only the flesh and only in moderation. The pits, stems, and leaves of plums contain cyanide, which is toxic to dogs, and the pits also pose a choking hazard.',
    canCatsEat: 'Moderate',
    catNotes: 'Cats can eat a small piece of ripe plum flesh. Avoid the pit, leaves, and stem entirely due to cyanide content.'
  },
  {
    name: 'Parsley',
    canDogsEat: 'Moderate',
    dogNotes: 'Dogs can eat fresh, flat-leaf parsley in small amounts—it’s rich in vitamins and may help freshen breath. Avoid feeding large quantities or using spring parsley (a toxic variety), especially for pregnant dogs or those with kidney issues.',
    canCatsEat: 'Moderate',
    catNotes: 'Cats can eat a small amount of fresh, flat-leaf parsley occasionally. It contains antioxidants and vitamins, but large quantities can be harmful, especially spring parsley which may cause photosensitivity or digestive upset.'
  },
];
